// pages/Ocupacion.js
import React, { useState, useEffect } from 'react';
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Space,
  Typography,
  message,
  Tag,
  Tooltip,
  Row,
  Col,
  Statistic,
  Card,
  DatePicker,
  Select,
  InputNumber,
  Divider,
  Badge,Collapse,Tabs
} from 'antd';
import {
  SearchOutlined,
  ReloadOutlined,CalculatorOutlined,PercentageOutlined ,TeamOutlined ,RiseOutlined,ShoppingOutlined ,
  EyeOutlined,
  ExportOutlined,
  AppstoreOutlined,
  CalendarOutlined,
  HomeOutlined,
  UserOutlined,
  DollarOutlined,
  BarChartOutlined,
  FilterOutlined,
  LineChartOutlined
} from '@ant-design/icons';
import axios from 'axios';
import dayjs from 'dayjs';

import PageContainer from '../components/PageContainer';
import { BASE_URL } from '../utils/constants';

const { Title, Text } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
const { Panel } = Collapse;



const Ocupacion = () => {

  const urlReportServer = JSON.parse(localStorage.getItem('urlReportServer') || '{}');    
  // Estados
  const [datosOcupacion, setDatosOcupacion] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [detalleRegistro, setDetalleRegistro] = useState(null);
  
  // Estados para filtros
  const [fechaInicio, setFechaInicio] = useState(dayjs());
  const [fechaFin, setFechaFin] = useState(dayjs());
  const [hotelSeleccionado, setHotelSeleccionado] = useState('1'); // ID del hotel
  
  // Estados para estadísticas
  const [estadisticas, setEstadisticas] = useState({
    promedioOcupacion: 0,
    totalPax: 0,
    totalImporte: 0,
    promedioImporte: 0,
    totalEntradas: 0,
    totalSalidas: 0,
    promedioImportePax: 0,
    promedioImporteHab: 0,
    mediaOcupacionPax: 0,
    mediaOcupacionHab: 0
  });

  // Configuración de columnas de la tabla
  const columns = [
    {
      title: 'Fecha',
      dataIndex: 'Fecha',
      key: 'Fecha',
      width: 120,
      fixed: 'left',
      sorter: (a, b) => new Date(a.Fecha) - new Date(b.Fecha),
      render: (fecha) => {
        const date = new Date(fecha);
        return (
          <div>
            <div style={{ fontSize: '12px', color: '#666' }}>
              {date.toLocaleDateString('es-ES', { weekday: 'short' })}
            </div>
            <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
              {date.toLocaleDateString('es-ES')}
            </div>
            <div style={{ fontSize: '11px', color: '#999' }}>
              {/* {date.getDate()} */}
            </div>
          </div>
        );
      },
    },
    {
      title: 'Día',
      dataIndex: 'NombreDiaSemana',
      key: 'NombreDiaSemana',
      width: 100,
      render: (nombreDia, record) => (
        <Tag 
          color={record.DiaSemana >= 6 ? 'orange' : 'blue'}
          style={{ fontWeight: 'bold' }}
        >
          {nombreDia}
        </Tag>
      ),
    },
    // {
    //   title: 'Hotel',
    //   dataIndex: 'NombreHotel',
    //   key: 'NombreHotel',
    //   width: 150,
    //   render: (nombreHotel) => (
    //     <div style={{ display: 'flex', alignItems: 'center' }}>
    //       <HomeOutlined style={{ marginRight: 8, color: '#1890ff' }} />
    //       <Text strong>{nombreHotel}</Text>
    //     </div>
    //   ),
    // },
    {
      title: 'Ocupación',
      children: [
        {
          title: 'InRes',
          dataIndex: 'InRes',
          key: 'InRes',
          width: 80,
          align: 'right',
          sorter: (a, b) => a.InRes - b.InRes,
          render: (value) => (
            <Badge 
              count={value} 
              style={{ backgroundColor: '#1890ff' }}
              showZero
            />
          ),
        },
        {
          title: 'DoRes',
          dataIndex: 'DoRes',
          key: 'DoRes',
          width: 80,
          align: 'right',
          sorter: (a, b) => a.DoRes - b.DoRes,
          render: (value) => (
                <div style={{ position: 'relative', display: 'inline-block' }}>
                    <span
                        style={{
                        backgroundColor: '#52c41a',
                        color: 'white',
                        borderRadius: '10px',
                        padding: '2px 8px',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        minWidth: '24px',
                        textAlign: 'center',
                        display: 'inline-block',
                        boxShadow: '0 0 0 1px #fff'
                        }}
                    >
                        {value || 0}
                    </span>
                </div>
          ),
        },
        {
          title: 'TrRes',
          dataIndex: 'TrRes',
          key: 'TrRes',
          width: 80,
          align: 'right',
          sorter: (a, b) => a.TrRes - b.TrRes,
          render: (value) => (
                <div style={{ position: 'relative', display: 'inline-block' }}>
                    <span
                        style={{
                        backgroundColor: '#faad14',
                        color: 'white',
                        borderRadius: '10px',
                        padding: '2px 8px',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        minWidth: '24px',
                        textAlign: 'center',
                        display: 'inline-block',
                        boxShadow: '0 0 0 1px #fff'
                        }}
                    >
                        {value || 0}
                    </span>
                </div>            
          ),
        },
        {
          title: 'CuRes',
          dataIndex: 'CuRes',
          key: 'CuRes',
          width: 80,
          align: 'right',
          sorter: (a, b) => a.CuRes - b.CuRes,
          render: (value) => (
                <div style={{ position: 'relative', display: 'inline-block' }}>
                    <span
                        style={{
                        backgroundColor: '#faad14',
                        color: 'white',
                        borderRadius: '10px',
                        padding: '2px 8px',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        minWidth: '24px',
                        textAlign: 'center',
                        display: 'inline-block',
                        boxShadow: '0 0 0 1px #fff'
                        }}
                    >
                        {value || 0}
                    </span>
                </div>            
          ),
        },        
        {
          title: 'QuRes',
          dataIndex: 'QuRes',
          key: 'QuRes',
          width: 80,
          align: 'right',
          sorter: (a, b) => a.QuRes - b.QuRes,
          render: (value) => (
                <div style={{ position: 'relative', display: 'inline-block' }}>
                    <span
                        style={{
                        backgroundColor: '#faad14',
                        color: 'white',
                        borderRadius: '10px',
                        padding: '2px 8px',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        minWidth: '24px',
                        textAlign: 'center',
                        display: 'inline-block',
                        boxShadow: '0 0 0 1px #fff'
                        }}
                    >
                        {value || 0}
                    </span>
                </div>            
          ),
        },                
        {
          title: 'Total',
          dataIndex: 'Ocupadas',
          key: 'Ocupadas',
          width: 100,
          align: 'right',
          sorter: (a, b) => a.Ocupadas - b.Ocupadas,
          render: (value, record) => {
            const porcentaje = ((value / 161) * 100).toFixed(1); // Asumiendo 161 habitaciones totales
            let color = '#52c41a';
            if (porcentaje < 60) color = '#faad14';
            if (porcentaje < 40) color = '#ff4d4f';
            
            return (
              <div>
                <Text strong style={{ fontSize: '16px' }}>{value}</Text>
                <div style={{ fontSize: '11px', color }}>
                  {porcentaje}%
                </div>
              </div>
            );
          },
        },
      ],
    },
    {
      title: 'Disponibilidad',
      children: [
        {
          title: 'Libres',
          dataIndex: 'Libres',
          key: 'Libres',
          width: 90,
          align: 'right',
          sorter: (a, b) => a.Libres - b.Libres,
          render: (value) => (
            <Tag color={value > 0 ? 'green' : 'red'} style={{ fontWeight: 'bold' }}>
              {value}
            </Tag>
          ),
        },
      ],
    },
    {
      title: 'Movimientos',
      children: [
        {
          title: 'Entradas',
          dataIndex: 'Entradas',
          key: 'Entradas',
          width: 90,
          align: 'right',
          sorter: (a, b) => a.Entradas - b.Entradas,
          render: (value) => (
            <Tag color="blue" style={{ fontWeight: 'bold' }}>
              {value}
            </Tag>
          ),
        },
        {
          title: 'Salidas',
          dataIndex: 'Salidas',
          key: 'Salidas',
          width: 90,
          align: 'right',
          sorter: (a, b) => a.Salidas - b.Salidas,
          render: (value) => (
            <Tag color="purple" style={{ fontWeight: 'bold' }}>
              {value}
            </Tag>
          ),
        },
      ],
    },
    {
      title: 'Pax',
      dataIndex: 'Pax',
      key: 'Pax',
      width: 100,
      align: 'right',
      sorter: (a, b) => a.Pax - b.Pax,
      render: (value) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          {/* <UserOutlined style={{ marginRight: 4, color: '#722ed1' }} /> */}
          <Text strong>{value}</Text>
        </div>
      ),
    },
    {
      title: 'Producción',
      dataIndex: 'ImporteProduccion',
      key: 'ImporteProduccion',
      width: 120,
      align: 'right',
      sorter: (a, b) => a.ImporteProduccion - b.ImporteProduccion,
      render: (value) => (
        <div>
          <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#52c41a' }}>
            €{(value || 0).toFixed(2)}
          </div>
          <div style={{ fontSize: '11px', color: '#999' }}>
            €{((value || 0) / (parseFloat(value) > 0 ? parseFloat(value) : 1)).toFixed(2)}/hab
          </div>
        </div>
      ),
    },
    {
      title: 'Bloq',
      dataIndex: 'Bloq',
      key: 'Bloq',
      width: 70,
      align: 'right',
      render: (value) => (
        <Badge 
          count={value} 
          style={{ 
            backgroundColor: value > 0 ? '#faad14' : '#d9d9d9'
          }}
          showZero
        />
      ),
    },
    {
      title: 'Acciones',
      key: 'acciones',
      width: 100,
      fixed: 'right',
      render: (_, record) => (
        <Tooltip title="Ver detalles">
          <Button
            type="default"
            icon={<EyeOutlined />}
            size="small"
            onClick={() => handleVerDetalles(record)}
          />
        </Tooltip>
      ),
    },
  ];

  // Cargar datos iniciales
  useEffect(() => {
    fetchDatosOcupacion();
  }, []);

  // Calcular estadísticas cuando cambian los datos
//   useEffect(() => {
//     if (datosOcupacion.length > 0) {
//       calcularEstadisticas();
//     }
//   }, [datosOcupacion]);

  const fetchDatosOcupacion = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      
      // Formatear fechas
      const fechaInicioFormatted = fechaInicio.format('DD/MM/YYYY');
      const fechaFinFormatted = fechaFin.format('DD/MM/YYYY');
       

      // console.log(" fechas => ",fechaInicioFormatted,fechaFinFormatted);
      
      
      const response = await axios.get(`${BASE_URL}/api/ocupacion`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
        //   hotelId: hotelSeleccionado,
          fechaInicio: fechaInicioFormatted,
          fechaFin: fechaFinFormatted
        }
      });

      // Limpiar y formatear los datos
      const datosLimpios = (response.data.data || []).map(item => ({
        ...item,
        Fecha: item.Fecha || '',
        ImporteProduccion: parseFloat(item.ImporteProduccion) || 0,
        Ocupadas: parseInt(item.Ocupadas) || 0,
        Libres: parseInt(item.Libres) || 0,
        Pax: parseInt(item.Pax) || 0,
        Entradas: parseInt(item.Entradas) || 0,
        Salidas: parseInt(item.Salidas) || 0
      }));
      
       console.log(" datosLimpios => ",datosLimpios);
      setEstadisticas(response.data.estadisticas)
      

      setDatosOcupacion(datosLimpios);

      // console.log(" Datos Limpios => ",datosLimpios);
      
      
      // console.log(`✅ Datos de ocupación cargados: ${datosLimpios.length} registros`);
      
    } catch (error) {
      console.error('❌ Error cargando datos de ocupación:', error);
      message.error('Error al cargar los datos de ocupación');
      setDatosOcupacion([]);
    } finally {
      setLoading(false);
    }
  };

//   const calcularEstadisticas = () => {
//     const totalRegistros = datosOcupacion.length;
    
//     const totalOcupadas = datosOcupacion.reduce((sum, item) => sum + (item.Ocupadas || 0), 0);
//     const totalPax = datosOcupacion.reduce((sum, item) => sum + (item.Pax || 0), 0);
//     const totalImporte = datosOcupacion.reduce((sum, item) => sum + (item.ImporteProduccion || 0), 0);
//     const totalEntradas = datosOcupacion.reduce((sum, item) => sum + (item.Entradas || 0), 0);
//     const totalSalidas = datosOcupacion.reduce((sum, item) => sum + (item.Salidas || 0), 0);
    
//     const promedioOcupacion = totalRegistros > 0 ? (totalOcupadas / totalRegistros / 161 * 100).toFixed(1) : 0;
//     const promedioImporte = totalRegistros > 0 ? (totalImporte / totalRegistros).toFixed(2) : 0;
    
//     setEstadisticas({
//       promedioOcupacion,
//       totalPax,
//       totalImporte,
//       promedioImporte,
//       totalEntradas,
//       totalSalidas
//     });
//   };

const imprimirInforme = async (codigoHotel) => {
  
  if (!codigoHotel) {
    message.warning('No hay datos disponibles para generar el informe');
    return;
  }

  const hideLoading = message.loading(`Generando informe....`, 0);  

  try {
    // Obtener token
    const token = localStorage.getItem('token');
    
    // Validar token
    if (!token) {
      throw new Error('No se encontró token de autenticación. Por favor, inicie sesión nuevamente.');
    }

     const fechaInicioFormatted = fechaInicio.format('DD/MM/YYYY');
     const fechaFinFormatted = fechaFin.format('DD/MM/YYYY');    

    // const fechaInicioFormatted = fechaInicio.format('YYYY-MM-DD');
    // const fechaFinFormatted = fechaFin.format('YYYY-MM-DD');        

    // Construir consulta SQL segura (evitar inyección SQL)
    const sqlQuery = `   select  CodigoHotel , cast(0 as bit) esfestivo , getdate() FechaActual , round((select [dbo].DevuelveHabsADR(Codigohotel,Fecha)),2) HabsADR, 
 		(select [dbo].DevuelveHabsYTD(CodigoHotel,Fecha)) HabsYTD, 
 
 		round((select [dbo].DevuelveImporteADias(CodigoHotel,Fecha,14)),0) Importe14Dias , 
 		round((select [dbo].DevuelveImporteADias(CodigoHotel,Fecha,7)),0)  Importe7Dias , 
 		round((select [dbo].DevuelveImporteADias(CodigoHotel,Fecha,2)),0)  Importe2Dias , 
 		(select [dbo].DevuelveHabsADias(Codigohotel,Fecha,14)) Habs14Dias , 
 		(select [dbo].DevuelveHabsADias(CodigoHotel,Fecha,2))  Habs2Dias , 
 		(select [dbo].DevuelveHabsADias(CodigoHotel,Fecha,7))  Habs7Dias , 
 		(select [dbo].[DevuelvePaxRegimen](CodigoHotel,Fecha,'PC')) PCRes , (select [dbo].[DevuelvePaxRegimen](CodigoHotel,Fecha,'MP')) MPRes , 
 		(select [dbo].[DevuelvePaxRegimen](CodigoHOtel,Fecha,'HD')) BBRes , 
 		(select [dbo].[DevuelvePaxRegimen](CodigoHotel,Fecha,'TI')) TIRes , 
 		(select [dbo].[DevuelvePaxRegimen](CodigoHotel,Fecha,'AL')) HARes , 
 		(Select [dbo].[DevuelvePaxYTD](CodigoHotel,Fecha) ) PaxYTD , 
 		(Select [dbo].[DevuelveRNM](CodigoHotel,Fecha,1,0) ) RNMGrupos  , 
 		(Select [dbo].[DevuelveRNM](CodigoHotel,Fecha,0,0) ) RNMIndividuales , 
 		round((Select [dbo].[DevuelveRNMProduccion](CodigoHotel,Fecha,1) ) ,2) ProduccionGrupos , 
 		round((Select [dbo].[DevuelveRNMProduccion](CodigoHotel,Fecha,0) ) ,2 ) ProduccionIndividuales, 
 		(Select [dbo].[DevuelveRNM](CodigoHotel,Fecha,1,1) ) RNMGruposHab  , 
 		(Select [dbo].[DevuelveRNM](CodigoHotel,Fecha,0,1) ) RNMIndividualesHab , 
 		round(case when fecha > FechaHotel then (select sum(PrecioDia) from [dbo].[CalculaPrecioporDia](CodigoHotel , Fecha,Fecha)) else 
 			(SELECT sum(ImporteProduccion) from  [dbo].[DevuelveBloqueadas] (CodigoHotel,Fecha,Fecha)) end ,2 ) ImporteProduccion , 
 
 		(SELECT isnull(sum(ImporteSalas),0) from  [dbo].[DevuelveBloqueadas] (CodigoHotel,Fecha,Fecha)) ImporteSalas , 
 		(SELECT isnull(sum(ImporteHostel),0) from  [dbo].[DevuelveBloqueadas] (CodigoHotel,Fecha,Fecha)) ImporteHostel , 
 
 		case when fecha > FechaHotel then (select sum(PrecioDia)-sum(desglose) from [dbo].[CalculaPrecioporDia](CodigoHotel,Fecha,Fecha)) else 
 			(SELECT isnull(sum(ImporteProduccion),0)-isnull(sum(ImporteADR),0) from  [dbo].[DevuelveBloqueadas] (CodigoHotel,Fecha,Fecha)) end ImporteADR  , 
 
      (select dbo.[DevuelveMes] (month(fecha))) qMes , (Select Nombre from Hoteles  with (nolock) where  Codigo = TablaPivot.CodigoHotel ) NombreHotel ,HabsFantasmas HabFantasmas , 
 		( select count(*) from Hostel_LinReservas  with (nolock) where  CodigoHotel = TablaPivot.Codigohotel and entrada <= tablapivot.fecha and salida > tablapivot.fecha and Anulada <> 1 ) Hostel , 
 		( select count(*) c from Hostel_Camas  with (nolock) where  CodigoHotel = TablaPivot.Codigohotel ) HostalTotal  , 
 
 		case when GaranCont - Garantias >= 0 then ((isnull([1],0)+isnull([2],0)+isnull([3],0)+isnull([4],0)+isnull([5],0)+isnull([6],0)+isnull([10],0) - HabsFantasmas) + Bloqueadas+abs(GaranCont-Garantias)) 
 				else ((isnull([1],0)+isnull([2],0)+isnull([3],0)+isnull([4],0)+isnull([5],0)+isnull([6],0) - HabsFantasmas) + Bloqueadas) end TotRes_Garantia , 
 
 		round(((cast( case when GaranCont - Garantias >= 0 then ((isnull([1],0)+isnull([2],0)+isnull([3],0)+isnull([4],0)+isnull([5],0)+isnull([6],0)+isnull([10],0) - HabsFantasmas) + Bloqueadas+abs(GaranCont-Garantias)) 
 				else ((isnull([1],0)+isnull([2],0)+isnull([3],0)+isnull([4],0)+isnull([5],0)+isnull([6],0)+isnull([10],0) - HabsFantasmas) + Bloqueadas) end as float) ) * 100 ) / Habitaciones_Total,2) PorcenHabTotal_Garantia , 
 
 		round(((cast( isnull([1],0)+isnull([2],0)+isnull([3],0)+isnull([4],0)+isnull([5],0)+isnull([6],0)+isnull([10],0) - HabsFantasmas + Bloqueadas as float) )  * 100 ) / Habitaciones_Total,2) PorcenHabTotal , 
 		(isnull([1],0)+isnull([2],0)+isnull([3],0)+isnull([4],0)+isnull([5],0)+isnull([6],0)+isnull([10],0)) - HabsFantasmas + Bloqueadas Reservadas , 
 		Habitaciones_Total , null mes , isnull([1],0)+isnull([2],0)+isnull([3],0)+isnull([4],0)+isnull([5],0)+isnull([6],0)+isnull([10],0) - HabsFantasmas tot , HabPAx , 0 OrdenListado , 0 Hotel , 
 
 		Fecha , 
 		isnull([1],0) as 'IN' , isnull([2],0) as 'DO' , isnull([3],0) as 'TR' , isnull([4],0) as 'CU' , isnull([5],0) as 'QU' , isnull([6],0) as 'SE' , 
 		isnull([1],0) as 'INRes' , isnull([2],0) as 'DORes' , isnull([3],0) as 'TRRes' , isnull([4],0) as 'CURes' , isnull([5],0) as 'QURes' , isnull([6],0) as 'SERes' , 
      isnull([10],0) as 'MultRes' ,  		isnull([1],0)+isnull([2],0)+isnull([3],0)+isnull([4],0)+isnull([5],0)+isnull([6],0)+isnull([10],0) /*- HabsFantasmas*/ TOTRes , 
 		round((cast(isnull([1],0)+isnull([2],0)+isnull([3],0)+isnull([4],0)+isnull([5],0)+isnull([6],0)+isnull([10],0) /*- HabsFantasmas*/ as float) * 100 ) / Habitaciones_Total,2)  PorcenHab , 
      round(cast((Pax * 100 )as float) / HabPax,2)  PorcenPax , 
      Pax TotPax , 
 		Habitaciones_Total - (isnull([1],0)+isnull([2],0)+isnull([3],0)+isnull([4],0)+isnull([5],0)+isnull([6],0)+isnull([10],0)) - Bloqueadas LibresReal , 
 Habitaciones_Total - (isnull([1],0)+isnull([2],0)+isnull([3],0)+isnull([4],0)+isnull([5],0)+isnull([6],0)+isnull([10],0) - HabsFantasmas) - Bloqueadas LibresG , 
 
      Habitaciones_Total - (isnull([1],0)+isnull([2],0)+isnull([3],0)+isnull([4],0)+isnull([5],0)+isnull([6],0)+isnull([10],0)) - Bloqueadas -                      case when GaranCont - Garantias < 0 then 0 else (GaranCont - Garantias) end + FueraGaran Libres , 
 		Bloqueadas , GaranCont , Garantias , 
 		GaranCont - Garantias GaranLibres , FueraGaran , GaranCont - Garantias - FueraGaran DifGaran , 0 Cupo , 0 FueraCupo , 0 Confirmada , 0 LibresCupos , 
 		Pax , HabsFantasmas , 0 EsReservaDeBloqueo , datename(dw,Fecha) DiaSemana   , 
 ( select count(*) c from LinReserva 
      inner Join Reservas on Reservas.NumReserva = LinReserva.NumReserva 
 where  LinReserva.CodigoHotel = TablaPivot.CodigoHotel and LinReserva.Entrada = TablaPivot.Fecha    and LinReserva.numocupante = (select top 1 numocupante from linreserva l                                  where l.NumReserva = LinReserva.NumReserva and l.Linea = linreserva.linea and l.salida = l.FechaMaxSalida)    and Reservas.anulada <> 1 ) Entradas , 
 ( select count(*) c from LinReserva 
      inner Join Reservas on Reservas.NumReserva = LinReserva.NumReserva 
 where  LinReserva.CodigoHotel = TablaPivot.CodigoHotel and LinReserva.Salida = TablaPivot.Fecha    and linreserva.numocupante = 1 
   and Reservas.anulada <> 1 ) Salida  
 
 
 
 
 from ( 
 select CodigoHotel , FechaHotel , Fecha , sum(HabsFantasmas) HabsFantasmas , (Habitaciones_TOtal) Habitaciones_Total , sum(bloqueadas) Bloqueadas , 
		sum(GaranCont) GaranCont , HabPax HabPax , sum(Garantias) Garantias , sum(FueraGaran) FueraGaran , sum(Pax) Pax , TipoHab , sum(c) c from ( 
 	select   LinReserva.CodigoHotel,( select ultcierre from opciones   with (nolock) where CodigoHotel = LinReserva.CodigoHotel ) FechaHotel ,          ReservasExtra.Fecha , (select dbo.HabitacionesFantasmas(LinReserva.CodigoHotel,ReservasExtra.Fecha)) HabsFantasmas , 
 			(select Habin + habdo + habtr + habqu + habcu from Opciones  with (nolock) where  CodigoHotel = LinReserva.CodigoHotel ) Habitaciones_Total , 
 			(SELECT cuantas from  [dbo].[DevuelveBloqueadas] (LinReserva.CodigoHotel,ReservasExtra.Fecha,ReservasExtra.Fecha)) Bloqueadas , 
 			(select dbo.DevuelveGarantiaSimple2(LinReserva.Codigohotel,ReservasExtra.Fecha)) GaranCont , 
 			(select HabPAx from Opciones where  CodigoHotel = LinReserva.CodigoHotel ) HabPAx , 
 			(select count(*) from LinReserva L  with (nolock) 
 				inner join ReservasExtra r  with (nolock) on r.numreserva = L.NumReserva and r.NumOcupante = L.NumOcupante and r.Linea = L.Linea 
 			 where  l.anulada <> 1 and L.CodigoHotel = LinReserva.CodigoHotel and r.fecha = ReservasExtra.Fecha and r.NumOcupante = 1 and Colocacion = 'GA') Garantias , 
 			(select count(*) from LinReserva L  with (nolock) 
 				inner join ReservasExtra r  with (nolock) on r.numreserva = L.NumReserva and r.NumOcupante = L.NumOcupante and r.Linea = L.Linea 
 			 where  l.anulada <> 1 and L.CodigoHotel = LinReserva.CodigoHotel and r.fecha = ReservasExtra.Fecha and r.NumOcupante = 1 and Colocacion = 'FG') FueraGaran , 
 			(select count(*) from LinReserva L  with (nolock) 
 				inner join ReservasExtra r  with (nolock) on r.numreserva = L.NumReserva and r.NumOcupante = L.NumOcupante and r.Linea = L.Linea 
 			 where  l.anulada <> 1 and L.CodigoHotel = LinReserva.CodigoHotel and r.fecha = ReservasExtra.Fecha  ) Pax , 
 
 			case when substring(LinReserva.TipoHab,1,2) = 'IN' then 1 when substring(LinReserva.TipoHab,1,2) = 'DO' then 2 
 				 when substring(LinReserva.TipoHab,1,2) = 'TR' then 3 when substring(LinReserva.TipoHab,1,2) = 'CU' then 4 
 				 when substring(LinReserva.TipoHab,1,2) = 'QU' then 5 when substring(LinReserva.TipoHab,1,2) = 'SE' then 6 else 10 end TipoHab , 
 			count(*) c from LinReserva  with (nolock) 
 		inner join Reservas on Reservas.numreserva = LinReserva.NumReserva and Reservas.CodigoHotel = LinReserva.CodigoHotel 
 		inner join ReservasExtra on ReservasExtra.CodigoHotel = LinReserva.CodigoHotel and ReservasExtra.numreserva = LinReserva.NumReserva and ReservasExtra.NumOcupante = LinReserva.NumOcupante and ReservasExtra.Linea = LinReserva.Linea 
 	where   LinReserva.CodigoHotel in ( select CodigoWeb from Hoteles where  Nombre in (  'HOTEL MAR BLAU'))      and fecha >= '${fechaInicioFormatted}' and fecha <= '${fechaFinFormatted}'   and LinReserva.numocupante = (select top 1 numocupante from linreserva l                                  where l.NumReserva = LinReserva.NumReserva and l.Linea = linreserva.linea and l.salida = l.FechaMaxSalida)       and LinReserva.habitacionescompartidas <> 1 and LinReserva.anulada <> 1 
 	group by LinReserva.CodigoHotel,ReservasExtra.Fecha , substring(LinReserva.TipoHab,1,2) 
 
 union all  	select   LinReserva.CodigoHotel,( select ultcierre from opciones   with (nolock) where CodigoHotel = LinReserva.Codigohotel ) FechaHotel , ReservasExtra.Fecha ,          0 /*(select dbo.HabitacionesFantasmas(LinReserva.CodigoHotel,ReservasExtra.Fecha)) */ HabsFantasmas , 
 			(select Habin + habdo + habtr + habqu + habcu from Opciones  with (nolock) where  CodigoHotel = LinReserva.CodigoHotel ) Habitaciones_Total , 
 		   0 Bloqueadas , 
 		   0 GaranCont , 
 		   (select HabPAx from Opciones where  CodigoHotel = LinReserva.CodigoHotel )  HabPAx , 
 		   0 Garantias , 
 		   0 FueraGaran , 
 		   0 Pax ,   
 
 			2 TipoHab , 
 			1 c from LinReserva  with (nolock) 
 		inner join Reservas on Reservas.numreserva = LinReserva.NumReserva and Reservas.CodigoHotel = LinReserva.CodigoHotel 
 		inner join ReservasExtra on ReservasExtra.CodigoHotel = linReserva.CodigoHotel and ReservasExtra.numreserva = LinReserva.NumReserva and ReservasExtra.NumOcupante = Linreserva.NumOcupante and ReservasExtra.Linea = LinReserva.Linea 
 	where  fecha >= '${fechaInicioFormatted}' and fecha <= '${fechaFinFormatted}' and ReservasExtra.NumOcupante = 1 
      and linreserva.habitacionescompartidas = 1 
 	   and  LinReserva.CodigoHotel in ( select CodigoHotel from Hoteles where  Nombre in (  'HOTEL MAR BLAU')) 	group by LinReserva.CodigoHotel,ReservasExtra.Fecha , LinReserva.NumHab 
   ) as tablagggg group by Habitaciones_Total , codigohotel , fechahotel , fecha , tipohab , HabPax 
 
 union all 
 
 	SELECT CODIGOHOTEL , (select ultcierre from opciones  with (nolock) where opciones.codigohotel = LinReserva.codigohotel) , Fecha , 0 HabsFantasmas , TotalHabitaciones , 
 			(SELECT cuantas from  [dbo].[DevuelveBloqueadas] (LinReserva.CodigoHotel,LinReserva.Fecha,LinReserva.Fecha)) HabsBloqueadas , 
          (select dbo.DevuelveGarantiaSimple2(LinReserva.Codigohotel,LinReserva.Fecha)) GarantCont , (select habpax from opciones  with (nolock) where opciones.codigohotel = LinReserva.codigohotel) HabPax , 0 Garantias , 0 FueraGaran , 0 pax , 
 			0 TipoHab , 0 c 
 	FROM [dbo].[DiasSinReservasCompleto] ('${fechaInicioFormatted}','${fechaFinFormatted}') LinReserva 
 	   where  LinReserva.CodigoHotel in ( select CodigoWeb from Hoteles where  Nombre in (  'HOTEL MAR BLAU'))  
 ) as Tabla 
 pivot 
 (sum(c) for TipoHab in ([1],[2],[3],[4],[5],[6],[10]) ) as tablapivot 
 
 order by NombreHotel , fecha `;

  const sqlQuery2 = `  SELECT * FROM MegaConsultaPlaning (${codigoHotel},'${fechaInicioFormatted}','${fechaFinFormatted}') `
    
  // console.log(" sqlQuery2 => ",sqlQuery2);
  
    // Realizar la petición
    const response = await fetch(`${urlReportServer}/report`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        // 'Authorization': token ? `Bearer ${token}` : ''
      },
      body: JSON.stringify({
        hotelCode: codigoHotel,
        reportName: "Listado ocupacion",
        sqlQuery: sqlQuery2
      }),
      mode: 'cors', // Asegurar que usa CORS
      credentials: 'omit' // No enviar cookies si no las necesitas
    });

    // Cerrar loading
    hideLoading();

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error response:', errorText);
      
      let errorMsg = `Error ${response.status}`;
      try {
        const errorData = JSON.parse(errorText);
        if (errorData.error) {
          errorMsg = errorData.error;
        }
      } catch (e) {
        // Si no es JSON, usar el texto
        if (errorText) {
          errorMsg = errorText;
        }
      }
      throw new Error(errorMsg);
    }

    // Obtener el texto de la respuesta antes de parsear
    const responseText = await response.text();
    // console.log('Respuesta recibida (primeros 200 chars):', responseText.substring(0, 200));
    
    let data;
    try {
      data = JSON.parse(responseText);
    } catch (parseError) {
      console.error('Error parseando JSON:', parseError);
      console.error('Texto recibido:', responseText);
      
      // Intentar limpiar el texto
      const cleanText = responseText
        .replace(/[\x00-\x1F\x7F-\x9F]/g, '') // Eliminar caracteres de control
        .replace(/\r/g, '')
        .replace(/\n/g, '');
      
      try {
        data = JSON.parse(cleanText);
      } catch (e) {
        throw new Error('El servidor devolvió datos inválidos. Contacte con el administrador.');
      }
    }
    
    if (!data.success) {
      throw new Error(data.error || 'Error al generar el reporte');
    }

    if (!data.pdfbase64) {
      throw new Error('No se recibió el PDF');
    }

    // Mostrar PDF
    try {
      // Limpiar el Base64 (eliminar posibles caracteres extraños)
      let pdfBase64 = data.pdfbase64
        .replace(/[\x00-\x1F\x7F-\x9F]/g, '') // Eliminar caracteres de control
        .replace(/\s/g, ''); // Eliminar espacios en blanco
      
      const byteCharacters = atob(pdfBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      
      // Abrir en nueva ventana
      window.open(url, '_blank');
      
      // Limpiar URL después de 10 segundos
      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, 10000);


    } catch (pdfError) {
      console.error('Error mostrando PDF:', pdfError);
      throw new Error('Error al mostrar el PDF: ' + pdfError.message);
    }

  } catch (error) {
    // Cerrar loading si está abierto
    hideLoading();

    console.error('Error al generar informe:', error);

    // Manejar errores específicos
    let errorMessage = 'Ocurrió un error al generar el informe.';

    if (error.code === 'ECONNABORTED') {
      errorMessage = 'Tiempo de espera agotado. El servidor no responde.';
    } else if (error.response) {
      // El servidor respondió con un error
      const status = error.response.status;
      const data = error.response.data;

      switch (status) {
        case 400:
          errorMessage = 'Solicitud inválida. Verifique los datos enviados.';
          break;
        case 401:
          errorMessage = 'No autorizado. Su sesión ha expirado. Por favor, inicie sesión nuevamente.';
          // Opcional: redirigir al login
          // window.location.href = '/login';
          break;
        case 403:
          errorMessage = 'No tiene permisos para generar este reporte.';
          break;
        case 404:
          errorMessage = 'El endpoint del reporte no fue encontrado.';
          break;
        case 500:
          errorMessage = 'Error interno del servidor. Por favor, intente más tarde.';
          break;
        default:
          errorMessage = data?.error || data?.message || `Error ${status}: ${error.response.statusText}`;
      }
    } else if (error.request) {
      // La petición se hizo pero no hubo respuesta
      errorMessage = 'El servidor no responde. Verifique su conexión a la red.';
    } else if (error.message) {
      errorMessage = error.message;
    }

    // Mostrar error
    Modal.error({
      title: 'Error',
      content: errorMessage,
      onOk: () => {
        // Si es error de autenticación, redirigir al login
        if (errorMessage.includes('No autorizado') || errorMessage.includes('sesión ha expirado')) {
          // Redirigir al login
          // window.location.href = '/login';
        }
      }
    });
  }
};

  const handleVerDetalles = (registro) => {
    setDetalleRegistro(registro);
    setModalVisible(true);
  };

  const handleBuscar = () => {
    if (!fechaInicio || !fechaFin) {
      message.warning('Por favor seleccione un rango de fechas');
      return;
    }
    
    if (fechaInicio.isAfter(fechaFin)) {
      message.warning('La fecha de inicio debe ser anterior a la fecha de fin');
      return;
    }
    
    fetchDatosOcupacion();
  };

  const handleReset = () => {
    setFechaInicio(dayjs('2023-08-01'));
    setFechaFin(dayjs('2023-08-31'));
    setHotelSeleccionado('1');
  };

  const handleExportar = () => {
    // Implementar exportación a Excel/PDF
    message.info('Función de exportación en desarrollo');
  };

  // Componente de filtros
  const filtros = (
    <Card 
      size="small" 
      style={{ marginBottom: 16, backgroundColor: '#fafafa' }}
      title={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <FilterOutlined style={{ marginRight: 8 }} />
          <span>Filtros de Búsqueda</span>
        </div>
      }
    >
      <Row gutter={[16, 16]} align="middle">
        {/* <Col xs={24} sm={8}>
          <div style={{ marginBottom: 8 }}>
            <Text strong>Hotel:</Text>
          </div>
          <Select
            value={hotelSeleccionado}
            onChange={setHotelSeleccionado}
            style={{ width: '100%' }}
            suffixIcon={<HomeOutlined />}
          >
            <Option value="1">Dwo Sirius</Option>
            <Option value="2">Otro Hotel</Option>
          </Select>
        </Col> */}
        
        <Col xs={24} sm={12}>
          <div style={{ marginBottom: 8 }}>
            <Text strong>Rango de Fechas:</Text>
          </div>
          <RangePicker
            value={[fechaInicio, fechaFin]}
            onChange={(dates) => {
              if (dates && dates[0] && dates[1]) {
                setFechaInicio(dates[0]);
                setFechaFin(dates[1]);
              }
            }}
            style={{ width: '100%' }}
            format="DD/MM/YYYY"
            suffixIcon={<CalendarOutlined />}
          />
        </Col>
        
        <Col xs={24} sm={4}>
          <Space style={{ marginTop: 24 }}>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={handleBuscar}
              loading={loading}
            >
              Buscar
            </Button>
            <Button
              icon={<ReloadOutlined />}
              onClick={handleReset}
            >
              Restablecer
            </Button>
            <Button
              icon={<EyeOutlined />}
              onClick={() => imprimirInforme(datosOcupacion[0]?.CodigoHotel)}
            >
              Imprimir
            </Button>            
          </Space>
        </Col>
      </Row>
    </Card>
  );

  // Componente de estadísticas
  const panelEstadisticas = (
    <>
    <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
      <Col xs={24} sm={6}>
        <Card size="small">
          <Statistic
            title="Ocupación Promedio"
            value={`${estadisticas.promedioOcupacion}%`}
            prefix={<BarChartOutlined />}
            valueStyle={{ color: '#1890ff' }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={6}>
        <Card size="small">
          <Statistic
            title="Total Pax"
            value={estadisticas.totalPax}
            prefix={<UserOutlined />}
            valueStyle={{ color: '#722ed1' }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={6}>
        <Card size="small">
          <Statistic
            title="Total Producción"
            value={`€${estadisticas.totalImporte.toFixed(2)}`}
            prefix={<DollarOutlined />}
            valueStyle={{ color: '#52c41a' }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={6}>
        <Card size="small">
          <Statistic
            title="Producción Promedio"
            value={`€${estadisticas.promedioImporte}`}
            prefix={<LineChartOutlined />}
            valueStyle={{ color: '#faad14' }}
          />
        </Card>
      </Col>
    </Row>
    <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
      <Col xs={24} sm={6}>
        <Card size="small">
          <Statistic
            title="Media ocupación (Hab)"
            value={`${estadisticas.mediaOcupacionHab}%`}
            prefix={<HomeOutlined />}  
            valueStyle={{ color: '#13c2c2' }} 
          />
          <div style={{ fontSize: '12px', color: '#666', marginTop: 4 }}>
            Por habitación disponible
          </div>          
        </Card>
      </Col>
      <Col xs={24} sm={6}>
        <Card size="small">
          <Statistic
            title="Media ocupación (Pax)"
            value={`${estadisticas.mediaOcupacionPax}%`}
            prefix={<TeamOutlined />}  
            valueStyle={{ color: '#eb2f96' }}  
          />
          <div style={{ fontSize: '12px', color: '#666', marginTop: 4 }}>
            Pax por habitación ocupada
          </div>          
        </Card>
      </Col>
      <Col xs={24} sm={6}>
        <Card size="small">
          <Statistic
            title="Media producción (Hab)"
            value={`€${estadisticas.promedioImporteHab}`}
            prefix={<RiseOutlined  />}
            valueStyle={{ color: '#f5222d' }}
          />
          <div style={{ fontSize: '12px', color: '#666', marginTop: 4 }}>
            € por habitación ocupada
          </div>          
        </Card>
      </Col>
      <Col xs={24} sm={6}>
        <Card size="small">
          <Statistic
            title="Media producción (Pax)"
            value={`€${estadisticas.promedioImportePax}`}
            prefix={<ShoppingOutlined  />}
            valueStyle={{ color: '#fa8c16' }}
          />
          <div style={{ fontSize: '12px', color: '#666', marginTop: 4 }}>
            € por persona
          </div>          
        </Card>
      </Col>
    </Row>
    </>    
  );

  return (
    <>
      <PageContainer
        title="Ocupación"
        subtitle={`Análisis de ocupación hotelera`}
        icon={<HomeOutlined />}
        loading={loading}
        onRefresh={() => fetchDatosOcupacion()}
        badgeCount={datosOcupacion.length}
        badgeStatus="success"
        extra={
          <Space>
            <Button
              icon={<ExportOutlined />}
              onClick={handleExportar}
            >
              Exportar
            </Button>
            <Tag color="blue" style={{ fontSize: 14, padding: '4px 12px', borderRadius: 20 }}>
              <strong>{datosOcupacion.length}</strong> días
            </Tag>
          </Space>
        }
        cardStyle={{
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
        }}
      >
        {/* Filtros */}
        {filtros}
        
        {/* Estadísticas */}
        {panelEstadisticas}
        
        
        {/* Tabla de datos */}
        <Table
          columns={columns}
          dataSource={datosOcupacion}
          rowKey={(record) => record.Fecha}
          loading={loading}
        //   scroll={{ x: 1500, y: 600 }}
          style={{
            borderRadius: '8px',
            overflow: 'hidden'
          }}
          pagination={false}
          size="middle"
          locale={{
            emptyText: 'No se encontraron datos de ocupación'
          }}
          summary={() => (
            <Table.Summary fixed="bottom">
              <Table.Summary.Row style={{ backgroundColor: '#fafafa50', fontWeight: 'bold' }}>
                <Table.Summary.Cell index={0} colSpan={2}>
                  <Text strong>TOTALES / PROMEDIOS</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} align="right">
                  <Text strong>{datosOcupacion.reduce((sum, item) => sum + (item.InRes || 0), 0)}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} align="right">
                  <Text strong>{datosOcupacion.reduce((sum, item) => sum + (item.DoRes || 0), 0)}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3} align="right">
                  <Text strong>{datosOcupacion.reduce((sum, item) => sum + (item.TrRes || 0), 0)}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3} align="right">
                  <Text strong>{datosOcupacion.reduce((sum, item) => sum + (item.CuRes || 0), 0)}</Text>
                </Table.Summary.Cell>                
                <Table.Summary.Cell index={3} align="right">
                  <Text strong>{datosOcupacion.reduce((sum, item) => sum + (item.QuRes || 0), 0)}</Text>
                </Table.Summary.Cell>                
                <Table.Summary.Cell index={4} align="right">
                  <Text strong>{datosOcupacion.reduce((sum, item) => sum + (item.Ocupadas || 0), 0)}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5} align="right">
                  <Text strong>{datosOcupacion.reduce((sum, item) => sum + (item.Libres || 0), 0)}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6} align="right">
                  <Text strong>{estadisticas.totalEntradas}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={7} align="right">
                  <Text strong>{estadisticas.totalSalidas}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={8} align="right">
                  <Text strong>{estadisticas.totalPax}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={9} align="right">
                  <Text strong style={{ color: '#52c41a' }}>
                    €{estadisticas.totalImporte.toFixed(2)}
                  </Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={10} align="right">
                  <Text strong>{datosOcupacion.reduce((sum, item) => sum + (item.Bloq || 0), 0)}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={11} align="center">
                  <Text type="secondary">-</Text>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          )}
        />
      </PageContainer>

      {/* Modal de detalles */}
      <Modal
        title="Detalles de Ocupación"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        width={800}
        footer={[
          <Button key="close" onClick={() => setModalVisible(false)}>
            Cerrar
          </Button>
        ]}
        style={{ top: 20 }}
      >
        {detalleRegistro && (
          <div style={{ marginTop: 20 }}>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Card size="small" style={{ backgroundColor: '#e6f7ff' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <Title level={4} style={{ margin: 0 }}>
                        {detalleRegistro.NombreHotel} - {new Date(detalleRegistro.Fecha).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                      </Title>
                      <Text type="secondary">{detalleRegistro.NombreDiaSemana}</Text>
                    </div>
                    <Tag color="blue" style={{ fontSize: '18px', padding: '8px 16px' }}>
                      {detalleRegistro.Ocupadas} / 161 Hab. ({((detalleRegistro.Ocupadas / 161) * 100).toFixed(1)}%)
                    </Tag>
                  </div>
                </Card>
              </Col>

              <Col span={8}>
                <Card size="small" title="Reservas por Tipo" style={{ height: '100%' }}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ marginBottom: 8 }}>
                      <Text strong>Individuales:</Text>
                      <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#1890ff' }}>
                        {detalleRegistro.InRes}
                      </div>
                    </div>
                    <div style={{ marginBottom: 8 }}>
                      <Text strong>Dobles:</Text>
                      <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#52c41a' }}>
                        {detalleRegistro.DoRes}
                      </div>
                    </div>
                    <div>
                      <Text strong>Triples:</Text>
                      <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#faad14' }}>
                        {detalleRegistro.TrRes}
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>

              <Col span={8}>
                <Card size="small" title="Movimientos" style={{ height: '100%' }}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ marginBottom: 16 }}>
                      <Text strong>Entradas:</Text>
                      <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#1890ff' }}>
                        {detalleRegistro.Entradas}
                      </div>
                    </div>
                    <div>
                      <Text strong>Salidas:</Text>
                      <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#722ed1' }}>
                        {detalleRegistro.Salidas}
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>

              <Col span={8}>
                <Card size="small" title="Métricas" style={{ height: '100%' }}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ marginBottom: 8 }}>
                      <Text strong>Pax Total:</Text>
                      <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#722ed1' }}>
                        {detalleRegistro.Pax}
                      </div>
                    </div>
                    <div style={{ marginBottom: 8 }}>
                      <Text strong>Habitaciones Libres:</Text>
                      <div style={{ fontSize: '24px', fontWeight: 'bold', color: detalleRegistro.Libres > 0 ? '#52c41a' : '#ff4d4f' }}>
                        {detalleRegistro.Libres}
                      </div>
                    </div>
                    <div>
                      <Text strong>Bloqueos:</Text>
                      <div style={{ fontSize: '20px', fontWeight: 'bold', color: detalleRegistro.Bloq > 0 ? '#faad14' : '#999' }}>
                        {detalleRegistro.Bloq}
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>

              <Col span={24}>
                <Card size="small" title="Producción del Día" style={{ backgroundColor: '#f6ffed' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <Text strong style={{ fontSize: '16px' }}>Importe Total:</Text>
                      <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#52c41a' }}>
                        €{detalleRegistro.ImporteProduccion.toFixed(2)}
                      </div>
                    </div>
                    <div>
                      <Text strong style={{ fontSize: '16px' }}>Por Habitación:</Text>
                      <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#1890ff' }}>
                        €{(detalleRegistro.ImporteProduccion / (detalleRegistro.Ocupadas || 1)).toFixed(2)}
                      </div>
                    </div>
                    <div>
                      <Text strong style={{ fontSize: '16px' }}>Por Pax:</Text>
                      <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#722ed1' }}>
                        €{(detalleRegistro.ImporteProduccion / (detalleRegistro.Pax || 1)).toFixed(2)}
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>

              <Col span={24}>
                <Divider />
                <Card size="small" title="Información Adicional">
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <Text strong>Garantías C:</Text>
                      <div>{detalleRegistro.GarantiasC || 0}</div>
                    </Col>
                    <Col span={8}>
                      <Text strong>Garantías:</Text>
                      <div>{detalleRegistro.Garantias || 0}</div>
                    </Col>
                    <Col span={8}>
                      <Text strong>Día Semana (Núm):</Text>
                      <div>{detalleRegistro.DiaSemana}</div>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </div>
        )}
      </Modal>
    </>
  );
};

export default Ocupacion;